/**
 * Senkrechte Vorschauspalte der Produktseite (nur Desktop).
 *
 * Die Spalte schaltet das Hauptbild NICHT selbst um. Sie loest stattdessen
 * die zugehoerige Original-Schaltflaeche von Dawn aus (gleiches
 * `data-target`). Damit bleibt alles bei Dawn: aktives Medium, aria-current,
 * Variantenwechsel, Videostart. Faellt dieses Skript aus, ist die Seite
 * weiterhin bedienbar — nur eben ueber Dawns Streifen.
 *
 * Der aktive Rahmen wird von Dawn gespiegelt statt selbst gesetzt: so
 * stimmt er auch, wenn das Bild ueber die Variantenauswahl oder das
 * Wischen im Hauptbild wechselt.
 */
(function () {
  var strip = document.querySelector('.sh-gal__thumbs');
  if (!strip) return;

  var gallery = strip.closest('media-gallery');
  if (!gallery) return;

  /* WICHTIG: `data-target` sitzt bei Dawn auf dem <li>, der Klick-Zuhoerer
     aber auf dessen <button> (siehe media-gallery.js). Ein Klick auf das <li>
     loest deshalb gar nichts aus — es muss der Knopf darin sein. */
  function dawnButton(target) {
    var item = gallery.querySelector('[data-target="' + target + '"]');
    return item ? item.querySelector('button') : null;
  }

  strip.addEventListener('click', function (event) {
    var thumb = event.target.closest('.sh-gal__thumb');
    if (!thumb) return;
    var original = dawnButton(thumb.getAttribute('data-sh-thumb'));
    if (original) original.click();
  });

  function sync() {
    var thumbs = strip.querySelectorAll('.sh-gal__thumb');
    for (var i = 0; i < thumbs.length; i++) {
      var original = dawnButton(thumbs[i].getAttribute('data-sh-thumb'));
      var active = original && original.getAttribute('aria-current') === 'true';
      thumbs[i].classList.toggle('is-active', !!active);
    }
  }

  // Dawn setzt aria-current auf seinen Schaltflaechen — daran haengen wir uns.
  var thumbList = gallery.querySelector('.thumbnail-list');
  if (thumbList && window.MutationObserver) {
    new MutationObserver(sync).observe(thumbList, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-current'],
    });
  }
  sync();
})();
